import { ItemKind } from '../../../constants/ItemKind';
import { encodeItemId } from '../parsers/item-id';
import { systemFolderId } from '../../../constants/system-folder-id';
export function siteToFolder(siteData) {
  return {
    id: encodeItemId(siteData.site_token, systemFolderId.SiteFiles),
    kind: ItemKind.Folder,
    source: 'wixSite',
    parentId: 'wix-sites',
    name: siteData.display_name || siteData.name,
    createdAt: siteData.created,
    updatedAt: siteData.updated,
    siteId: siteData.id,
    userId: siteData.user_id,
    tags: []
  };
}